import React from "react";
import styled from "styled-components";
import media from "../../static/style/media";
import { useTranslation } from "react-i18next"
import ppsLogo from "../../image/ppsol_new.png";
// import ppsLogo from "../../image/ngiilogo.png";
import ppsLogo_ja from "../../image/locateU.png";
import { getLocalStorageWithExpiry } from "../../locales/langFunc";

const lang = getLocalStorageWithExpiry("i18nextLng");
let logo = lang === "ja" ? ppsLogo_ja : ppsLogo;

export default function Footer() {
  const { t } = useTranslation();
  return (
    <Container>
      <FooterContent>
        <FooterText>{t(`02-6925-1516 | ppsol@ppsol.com`)}</FooterText>
        <FooterText>
          {t(
            `B-2311, 606 Seobusaet-gil, Geumcheon-gu, Seoul, 08504, Republic of Korea`
          )}
        </FooterText>
      </FooterContent>
      <FooterBottom>
        <FooterLogo src={logo} />
        <FooterText2>{t(`ⓒPP-SOLUTION INC. ALL RIGHTS RESERVED`)}</FooterText2>
      </FooterBottom>
      {/* Optional: Uncomment if social media icons are added
      <ButtonBox>
        <SocialLink href="https://blog.naver.com/ppsoln" target="_blank">
          <SiNaver size="20" color="gray" />
        </SocialLink>
        <SocialLink href="https://www.linkedin.com/company/ppsoln" target="_blank">
          <AiFillLinkedin size="30" color="gray" />
        </SocialLink>
        <SocialLink href="https://twitter.com/PPSolnGNSS" target="_blank">
          <AiOutlineTwitter size="30" color="gray" />
        </SocialLink>
        <SocialLink href="https://www.youtube.com/channel/UCWDiKoWdegvvBE_XPFUIIIQ" target="_blank">
          <AiFillYoutube size="30" color="gray" />
        </SocialLink>
      </ButtonBox>
      */}
    </Container>
  );
}

const Container = styled.div`
  padding: 20px 10px;
  font-family: "Kanit", sans-serif;
  max-width: 2500px;
  width: 100%;
  background-color: #f4f4f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-top: 20px;
`;

const FooterContent = styled.div`
  text-align: center;
  margin-bottom: 15px;
`;

const FooterText2 = styled.p`
  color: #6c6c6c;
  position: relative;
  top: 1px;
  font-size: 0.9rem;
  ${media.small`
    font-size: 0.8rem;
  `}
`;

const FooterText = styled.p`
  color: #6c6c6c;
  font-size: 0.9rem;
  margin-bottom: 10px;
  ${media.small`
    font-size: 0.8rem;
  `}
`;

const FooterBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const FooterLogo = styled.img`
  margin-right: 15px;
  ${'' /* width: 110px; */}
  width: 120px;
  height: 30px;
  ${'' /* ${media.small`
    width: 80px;
    height: 20px;
  `} */}
`;

const ButtonBox = styled.div`
  font-size: 40px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const SocialLink = styled.a`
  margin: 0 15px;
  color: gray;
  transition: color 0.3s;
  
  &:hover {
    color: #007bff;
  }
`;
